import ResponsiveGuide from 'components/misc/ResponsiveGuide'

export default function OnboardingLayout({children}) {
    return (
        <>
            <ResponsiveGuide/>
            <div className="flex flex-row justify-center w-screen min-h-screen bg-lightbg dark:bg-darkbg">
                <div className="">
                    onboarding layout
                    {children}
                </div>
            </div>
        </>
    )
}